import * as userService from '../../services/UserService';
import { normalizeJson } from '../../../shared/helpers';
import { defineStore } from "pinia";
import { useAuthenticationStore } from "./authentication";
import { useRepo } from "pinia-orm";
import User from '../../models/User';

function initialState() {
    return {
        fetchingUsers: false,
    };
}

export const useUsersStore = defineStore('usersModule', {
    state: () => ({
        ...initialState(),
        userRepo: useRepo(User),
    }),
    getters: {
        allUsersExceptMe(state) {
            return state.userRepo.where(user => {
                const authStore = useAuthenticationStore();
                return user.id !== authStore.currentUserId;
            }).get().sort((a, b) => a.name.localeCompare(b.name));
        },
        allUsers(state) {
            return state.userRepo.with('companyUsers').get();
        }
    },
    actions: {
        fetchUsers(extraIncludes = null) {
            this.startFetchingUsers();

            return userService.index(extraIncludes)
                .then(result => {
                    return this.insertUsers(result.data);
                })
                .then(() => {
                    this.stopFetchingUsers();
                });
        },
        insertUsers(users) {
            return this.userRepo.save(normalizeJson(users));
        },
        resetState() {
            Object.assign(this, initialState());
        },
        startFetchingUsers() {
            this.fetchingUsers = true;
        },
        stopFetchingUsers() {
            this.fetchingUsers = false;
        },
    }
});
